import { Dictionary } from '@src/app/constants';

/**
 * Статусы отчёта
 */
export const REPORT_STATUS: Dictionary[] = [
  { id: 0, name: 'Отключен' }, // INFO: (по умолчанию)
  { id: 1, name: 'Включен' },
];
